import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const PaginationCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [total, setTotal] = useState('100');
  const [limit, setLimit] = useState('10');
  const [page, setPage] = useState('1');
  const [res, setRes] = useState<any>(null);

  const calculate = () => {
    const t = parseInt(total) || 0;
    const l = parseInt(limit) || 1;
    const p = parseInt(page) || 1;
    const totalPages = Math.ceil(t / l);
    const offset = (p - 1) * l;
    setRes({ totalPages, offset, start: offset + 1, end: Math.min(offset + l, t) });
    onResultChange([{ label: 'Total Páginas', value: totalPages.toString() }, { label: 'Offset', value: offset.toString() }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Total Itens" value={total} onChange={setTotal} isInteger required />
          <FormField label="Limite" value={limit} onChange={setLimit} isInteger required />
          <FormField label="Página" value={page} onChange={setPage} isInteger required />
        </div>
        <div className="flex justify-center mb-8">
          <button onClick={calculate} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="play" className="w-5 h-5" /> Calcular</button>
        </div>
        {res && (
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <ResultCard title="Páginas" value={res.totalPages} color="indigo" />
            <ResultCard title="Offset" value={res.offset} color="blue" />
            <ResultCard title="Início" value={res.start} color="purple" />
            <ResultCard title="Fim" value={res.end} color="emerald" />
          </div>
        )}
      </div>
    </div>
  );
};

export default PaginationCalculator;
